import { ModelDescriptionsManager } from "../../../OW.Remoting/Remoting/Cache/ClassDescriptionCache/ModelDescriptionsManager";
import { OWClassDescription } from "../../../OW.Remoting/Remoting/OWDescriptions";

export class ClassDescriptionLightDataSource {
    public async loadClassData(classNames: string[] | string): Promise<OWClassDescription[]> {
        const classes = typeof classNames === "string" ? [ classNames ] : classNames;
        const res: Promise<OWClassDescription>[] = [];

        for (const className of classes) {
            res.push(ModelDescriptionsManager.instance.getClassInfo(className) as Promise<OWClassDescription>);
        }

        return await Promise.all(res);
    }
}
